import { render, staticRenderFns } from "./DaySettings.vue?vue&type=template&id=5218cd0a&scoped=true&"
import script from "./DaySettings.vue?vue&type=script&lang=ts&"
export * from "./DaySettings.vue?vue&type=script&lang=ts&"
import style0 from "./DaySettings.vue?vue&type=style&index=0&id=5218cd0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5218cd0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VImg,VRow,VSelect,VSpacer})
